"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCatalogChannelBase = void 0;
const tslib_1 = require("tslib");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
const common_1 = require("@wix/wix-vod-constants/common");
const common_2 = require("@wix/wix-vod-shared/common");
const entity_id_1 = require("../normalizers/entity-id");
const video_item_1 = require("./video-item");
const mapTimestampToDate = (channel, targetKey) => {
    channel[targetKey] = new Date(channel[targetKey] * 1000);
};
const mapStatsInfo = (channel) => {
    // TODO: WHYYYY?
    if (channel.statsInfo) {
        channel.statsInfo = lodash_1.default.mapValues(channel.statsInfo, (list) => {
            // get rid of empty categories & tags
            const nonEmptyList = lodash_1.default.filter(list, (item) => Boolean(item.value));
            return lodash_1.default.uniqBy(nonEmptyList, 'value');
        });
    }
};
const cleanupVideoCountsForYoutubeFeed = (channel) => {
    // skip videosCount for youtube feed, should be done on BE
    if (channel.channelType !== common_1.CHANNEL_TYPES.CHANNEL) {
        delete channel.videosCount;
    }
};
const parseFeaturedItem = (channel) => {
    if (!channel.featuredItem) {
        return;
    }
    if (!channel.featuredItem.mediaStatus ||
        channel.featuredItem.mediaStatus === common_1.TRANSCODING_STATUSES.NONE) {
        delete channel.featuredItem;
        if (channel.videosCount) {
            channel.videosCount -= 1;
        }
        return;
    }
    if (channel.featuredItem.itemId) {
        // cleanup in new VOD backend version
        channel.featuredItem = (0, video_item_1.parseVideoItem)(channel.featuredItem);
    }
};
const parseCatalogChannelBase = (channel) => {
    channel = lodash_1.default.cloneDeep(channel);
    channel = (0, common_2.keysToCamelCase)(channel);
    mapTimestampToDate(channel, 'createdTs');
    mapTimestampToDate(channel, 'externalCreatedTs');
    mapTimestampToDate(channel, 'updatedTs');
    mapStatsInfo(channel);
    channel.id = (0, entity_id_1.normalizeId)(channel.itemId);
    channel.customCoverUrl = channel.customCoverUrl || null;
    channel.videosCount = channel.usedCount;
    channel.urlType = channel.urlType || '';
    channel.channelType = channel.channelType || common_1.CHANNEL_TYPES.CHANNEL;
    delete channel.itemId;
    delete channel.usedCount;
    delete channel.publishChanges;
    parseFeaturedItem(channel);
    cleanupVideoCountsForYoutubeFeed(channel);
    return channel;
};
exports.parseCatalogChannelBase = parseCatalogChannelBase;
//# sourceMappingURL=catalog-channel.js.map